module.exports = __webpack_public_path__ + "78bfd4793b6834bccf6b885cc5e4b7a0-811_6_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/eightOneOne/assets/811_6_2x.png
// module id = 619
// module chunks = 0